import { instance as axios, setJwtToken } from "../../config/axiosInstance";

// ------------------------Get Content Detail------------------
export const getContentApi = async (propertyTab) => {
  const endPoint = `admin/cms/list?language=${propertyTab}`;
  return await axios.get(endPoint, setJwtToken());
};

//   Update Content Detail
export const updateContentApi = async (data) => {
  const endPoint = `admin/cms`;
  return await axios.put(endPoint, data, setJwtToken());
};
